export default __webpack_public_path__ + "static/media/linkedin-icon-color.5db13b83.png";